<template>
  <div>
    <div v-if="$store.state.user.check_is_wxcblog_domain()" class="box mt-4 p-3 bolger-box sticky-top help">
      <span v-html="icons.helpcenter"></span>
      <span class="ml-3 mb-3 "><a href="http://www.haiwai.com/blog/c/618/4393" class="title font-weight-bold text-dark">帮助中心</a></span>
      <div class=row>
        <div class="col-12 mt-3 text-secondary help


"><a :href="$store.state.user.domain+'/blog/p/1636880'" class="small">复制文学城博客和相关问题解答</a></div>
      </div>
      <div class=row>
        <div class="col-6 mt-3 text-secondary help


"><a href="https://www.haiwai.com/blog/p/1636901" class="small">如何注册/登入</a></div>
        <div class="col-6 mt-3 text-secondary help


"><a href="https://www.haiwai.com/blog/p/1637701" class="small">如何隐藏目录</a></div>
      </div>
      <div class=row>
        <div class="col-6 mt-3 text-secondary help


"><a href="https://www.haiwai.com/blog/p/1448485" class="small">如何发博文</a></div>
        <div class="col-6 mt-3 text-secondary help


"><a href="https://www.haiwai.com/blog/p/1448486" class="small">如何上传图片</a></div>
      </div>
      <div class=row>
        <div class="col-6 mt-3  text-secondary help"><a href="https://www.haiwai.com/blog/p/1448487"
                                                        class="small">如何发视频</a></div>
        <div class="col-6 mt-3 text-secondary help


"><a href="https://www.haiwai.com/blog/p/1448488" class="small">如何贴音乐</a></div>
      </div>
      <!-- AD side3 -->
      <div data-aaad='true' data-aa-adunit='/339474670/Haiwai/Side3' class="ad_marginy"></div>
    </div>
    <div v-else class="box mt-4 p-3 bolger-box sticky-top help">
      <span v-html="icons.helpcenter"></span>
      <span class="ml-3 mb-3 "><a href="http://www.haiwai.com/blog/c/618/4393" class="title font-weight-bold text-dark">帮助中心</a></span>
      <div class=row>
        <div class="col-12 mt-3 text-secondary help


"><a href="https://www.haiwai.com/blog/p/1636880" class="small">复制文学城博客和相关问题解答</a></div>
      </div>
      <div class=row>
        <div class="col-6 mt-3 text-secondary help


"><a href="https://www.haiwai.com/blog/p/1636901" class="small">如何注册/登入</a></div>
        <div class="col-6 mt-3 text-secondary help


"><a href="https://www.haiwai.com/blog/p/1637701" class="small">如何隐藏目录</a></div>
      </div>
      <div class=row>
        <div class="col-6 mt-3 text-secondary help

"><a href="https://www.haiwai.com/blog/p/1448485" class="small">如何发博文</a></div>
        <div class="col-6 mt-3 text-secondary help
"><a href="https://www.haiwai.com/blog/p/1448486" class="small">如何上传图片</a></div>
      </div>
      <div class=row>
        <div class="col-6 mt-3  text-secondary help"><a href="https://www.haiwai.com/blog/p/1448487"
                                                        class="small">如何发视频</a></div>
        <div class="col-6 mt-3 text-secondary help
"><a href="https://www.haiwai.com/blog/p/1448488" class="small">如何贴音乐</a></div>
      </div>
      <!-- AD side3 -->
      <div data-aaad='true' data-aa-adunit='/339474670/Haiwai/Side3' class="ad_marginy"></div>
    </div>
  </div>
</template>
<script>
import icons from "@/components/Icons/Icons";

export default {
  name: 'blog-help',
  components: {},
  data() {
    return {

      icons: icons,
    };
  },
};
</script>
<style scoped>
#WxcColor .help a {
  color: #6c757d;
  font-size: 15px
}

#WxcColor .help a.title {
  color: #333;
  font-size: 18px
}

#WxcColor .help {
  padding: 10px 0
}

.help a {
  color: #6c757d;
  font-size: 1rem
}

.help a.title {
  font-size: 1.3rem
}

.bolger-box {
  background-color: #f6f9fc;
  border-radius: 16px;
  padding: 18px 0;
  z-index: auto
}
</style>
